import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=5187a0cf&scoped=true&"
import script from "./CatalogPage.vue?vue&type=script&lang=ts&"
export * from "./CatalogPage.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=5187a0cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187a0cf",
  null
  
)

export default component.exports